import { render, staticRenderFns } from "./unauthorized.vue?vue&type=template&id=4519ebf6&scoped=true&"
import script from "./unauthorized.component.ts?vue&type=script&lang=ts&"
export * from "./unauthorized.component.ts?vue&type=script&lang=ts&"
import style0 from "./unauthorized.scss?vue&type=style&index=0&id=4519ebf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4519ebf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/www/planning-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4519ebf6')) {
      api.createRecord('4519ebf6', component.options)
    } else {
      api.reload('4519ebf6', component.options)
    }
    module.hot.accept("./unauthorized.vue?vue&type=template&id=4519ebf6&scoped=true&", function () {
      api.rerender('4519ebf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/unauthorized/unauthorized.vue"
export default component.exports